// Spring newsletter — no-reload customer (newsletter) form submit.
// A generic wrapper mirroring the footer's hidden-iframe technique: we post the
// real form into a hidden iframe so Shopify's /contact endpoint accepts it (a
// background fetch POST is rejected) while the main page never navigates or
// scrolls. Any Meta Pixel (fbevents.js) force-submit lands in the iframe too,
// so it can't reload the page. After the iframe loads we show the returned
// status message inline. Any <spring-newsletter> with a single <form> works;
// the status paragraphs are marked with [data-newsletter-status].
class SpringNewsletter extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form || this.form.dataset.ajaxBound) return;
    this.form.dataset.ajaxBound = 'true';

    this.iframe = document.createElement('iframe');
    this.iframe.name =
      'spring-newsletter-sink-' + Math.random().toString(36).slice(2);
    this.iframe.setAttribute('aria-hidden', 'true');
    this.iframe.tabIndex = -1;
    this.iframe.style.cssText =
      'position:absolute;left:-9999px;width:0;height:0;border:0';
    document.body.appendChild(this.iframe);
    this.form.setAttribute('target', this.iframe.name);

    // Capture the true native submit now, before the Meta Pixel (fbevents.js)
    // wraps HTMLFormElement.prototype.submit.
    this.nativeSubmit = HTMLFormElement.prototype.submit;

    this.form.addEventListener('submit', (event) => {
      // preventDefault() stops the native top-level navigation and its #anchor
      // scroll. The Pixel otherwise cancels the default submission, so we force
      // the real submit into the hidden iframe ourselves. We don't stop
      // propagation, so the Pixel still sees the event and tracks the signup.
      event.preventDefault();
      this.pending = true;
      this.clearStatus();
      this.nativeSubmit.call(this.form);
    });
    this.iframe.addEventListener('load', () => this.showResult());
  }

  clearStatus() {
    const status = this.form.querySelector('[data-newsletter-status]');
    if (status) status.remove();
  }

  showResult() {
    if (!this.pending) return; // ignore the initial about:blank load
    this.pending = false;

    // Reuse Shopify's own (localized) status markup when the response is
    // same-origin; otherwise fall back to the message on the element.
    let status = null;
    try {
      const returned = this.iframe.contentDocument?.getElementById(this.form.id);
      const rendered = returned?.querySelector('[data-newsletter-status]');
      if (rendered) status = rendered.cloneNode(true);
    } catch (error) {
      /* cross-origin response — use the fallback below */
    }

    if (!status) {
      status = document.createElement('p');
      status.className =
        'spring-product-grid__form-status spring-product-grid__form-status--success spring-caption';
      status.setAttribute('role', 'status');
      status.setAttribute('data-newsletter-status', 'success');
      status.textContent =
        this.dataset.successMessage || 'Thanks for subscribing.';
    }

    this.clearStatus();
    this.form.appendChild(status);

    if (status.dataset.newsletterStatus !== 'error') {
      const input = this.form.querySelector('input[type="email"]');
      if (input) input.value = '';
    }
  }
}

customElements.define('spring-newsletter', SpringNewsletter);
